export default __webpack_public_path__ + "static/media/Short Details Card 2.aa351985.png";